import common from './common.json';

export const en = {
  common
};
